/* istanbul ignore file */

import type { HTMLInputTypeAttribute } from 'react';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

interface Event {
  action: string;
  fieldDetails?: FieldDetails;
  label: string;
}

export interface FieldDetails {
  field_name?: string;
  field_position: string;
  field_type: HTMLInputTypeAttribute | HTMLSelectElement['type'];
  form_section: string;
  required_field?: boolean;
}

export const event = ({ action, fieldDetails, label }: Event) => {
  const gaEvent = {
    event: 'custom_event',
    event_category: 'Partner Application',
    event_action: action,
    event_label: label,
    ...(fieldDetails ? { field_details: fieldDetails } : {}),
  };
  sendGAEvent(gaEvent);
};
